import { USER_FETCHED, USER_LOADED } from '../actions/users'

const defaultState = {
  loaded: false
}

let users = (state = defaultState, action) => {
  switch (action.type) {
    case USER_FETCHED:
      return Object.assign({}, state, {
        currentUserUsername: action.user.username
      })
    case USER_LOADED:
      return Object.assign({}, state, {
        loaded: true
      })
    default:
      break
  }
  return state
}

export default users
